import { useTranslation } from 'react-i18next'

import { CustomSelect } from '../../../CustomSelect'
import { FormFieldSelect } from '../../../Form'
import { FormikField } from '../../../Formik'
import { getTemplates } from '../FilterModalReplacement.api'
import { FILTER_REPLACEMENT_TEMPLATE_FIELD } from '../FilterModalReplacement.constants'

import { getLabel, getValue } from './FormFields.utils'

function FormFields({ entity }) {
  const { t } = useTranslation()

  const apiParams = { current_user_only: true, table_name: entity.plural }

  return (
    <FormikField
      Component={FormFieldSelect}
      Select={CustomSelect}
      api={getTemplates}
      apiParams={apiParams}
      getLabel={getLabel}
      getValue={getValue}
      inputLabel={t('Modal.ReplaceTemplateLabelKey')}
      listType='filter'
      name={FILTER_REPLACEMENT_TEMPLATE_FIELD}
      placeholder={t('Modal.ReplaceTemplatePlaceholderKey')}
      searchKey='search'
    />
  )
}

export default FormFields
